import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import {
	type AnalyticsAttributes,
	fireUIAnalytics,
	fireOperationalAnalytics,
	fireTrackAnalytics,
} from '@atlassian/jira-product-analytics-bridge';

type FireEmbeddedConfluenceAnalytics = {
	analyticsEvent: UIAnalyticsEvent;
	attributes: AnalyticsAttributes;
	eventType: string;
	eventName: string;
};

/* TO-DO: Implement Unit testing */
export const fireEmbeddedConfluenceAnalytics = ({
	analyticsEvent,
	attributes,
	eventType,
	eventName,
}: FireEmbeddedConfluenceAnalytics) => {
	switch (eventType) {
		case 'ui':
			fireUIAnalytics(analyticsEvent, attributes);
			break;
		case 'operational':
			fireOperationalAnalytics(analyticsEvent, `${eventName}`, attributes);
			break;
		case 'track':
			fireTrackAnalytics(analyticsEvent, `${eventName}`, attributes);
			break;
		default:
			fireUIAnalytics(analyticsEvent, attributes);
			break;
	}
};
